import React from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const PeptideInput = ({ peptide, onUpdate, onRemove, showRemove }) => {
  const handleIncrement = () => {
    const currentValue = parseFloat(peptide?.quantity || 0);
    onUpdate(peptide?.id, (currentValue + 1)?.toString());
  };

  const handleDecrement = () => {
    const currentValue = parseFloat(peptide?.quantity || 0);
    if (currentValue > 0) {
      onUpdate(peptide?.id, (currentValue - 1)?.toString());
    }
  };

  return (
    <div className="flex items-end gap-3">
      <div className="flex-1">
        <label className="text-sm font-medium text-foreground mb-2 block">
          {peptide?.name}
        </label>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="icon"
            onClick={handleDecrement}
            className="h-10 w-10"
          >
            <Icon name="Minus" size={16} />
          </Button>
          <Input
            type="number"
            value={peptide?.quantity}
            onChange={(e) => onUpdate(peptide?.id, e?.target?.value)}
            placeholder="0"
            className="text-center"
            min="0"
            step="0.1"
          />
          <Button
            variant="outline"
            size="icon"
            onClick={handleIncrement}
            className="h-10 w-10"
          >
            <Icon name="Plus" size={16} />
          </Button>
          <span className="text-sm text-muted-foreground whitespace-nowrap">mg</span>
        </div>
      </div>
      {showRemove && (
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onRemove(peptide?.id)}
          className="h-10 w-10 text-error hover:bg-error/10"
        >
          <Icon name="Trash2" size={16} />
        </Button>
      )}
    </div>
  );
};

export default PeptideInput;